import React from 'react';

type OwnProps = {
  className?: string;
};

const LargeAccount = ({ className }: OwnProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="52"
    height="52"
    viewBox="0 0 52 52"
    className={className}
  >
    <g>
      <g>
        <g>
          <path
            fill="none"
            stroke="#00aed9"
            strokeMiterlimit="50"
            strokeWidth="2"
            d="M26 51c13.807 0 25-11.193 25-25S39.807 1 26 1 1 12.193 1 26s11.193 25 25 25z"
          />
        </g>
        <g>
          <path
            fill="none"
            stroke="#00aed9"
            strokeMiterlimit="50"
            strokeWidth="2"
            d="M26.25 25.182c4.004 0 7.25-3.175 7.25-7.091 0-3.916-3.246-7.091-7.25-7.091S19 14.175 19 18.09c0 3.917 3.246 7.092 7.25 7.092z"
          />
        </g>
        <g>
          <path
            fill="none"
            stroke="#00aed9"
            strokeMiterlimit="50"
            strokeWidth="2"
            d="M41 36.666c-.309-2.083-1.222-4.122-2.741-6.116-1.519-1.994-2.786-2.819-3.801-2.474-2.269 2.384-4.922 3.57-7.958 3.56-3.036.01-5.689-1.176-7.958-3.56-1.015-.345-2.282.48-3.801 2.474-1.519 1.994-2.432 4.033-2.741 6.116"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default LargeAccount;
